<template>
  <a :href="story.content.link" target="_blank" class="newsroom-article">
    <div class="newsroom-article__publisher">{{ story.content.source }}</div>
    <div class="newsroom-article__info">
      <h6 class="newsroom-article__title">
        {{ story.content.title }}
      </h6>
      <p class="newsroom-article__description">
        {{ formattedDescription }}
      </p>
    </div>
  </a>
</template>

<script lang="ts" setup>
import type { SbNewsroomArticleStoryblok } from '@/types'

interface Props {
  story: SbNewsroomArticleStoryblok
}

const props = defineProps<Props>()

const formattedDescription = computed(() => {
  const maxChars = 80

  // slice at the last word before the maxChars
  if (!props.story.content.description?.slice) {
    return ''
  }
  const sliced = props.story.content.description.slice(0, maxChars)
  const lastSpace = sliced.lastIndexOf(' ')
  return `${sliced.slice(0, lastSpace)} ...`
})
</script>

<style lang="scss" scoped>
.newsroom-article {
  $root: #{&};

  border-top: 1px solid var(--paper-300);
  border-bottom: 1px solid var(--paper-300);
  margin-top: -1px;
  padding: 40px 0;
  display: flex;
  flex-direction: column;
  color: var(--cobalt-800);

  @media (min-width: $breakpoint-lg) {
    flex-direction: row;
  }

  &:hover {
    text-decoration: none;

    #{$root}__title {
      color: var(--color-link);
    }
  }

  &__title {
    margin-bottom: 6px;
  }

  &__publisher {
    min-width: 230px;
    margin-right: 0;
    font-size: var(--font-size-paragraph-s);
    margin-bottom: 24px;

    @media (min-width: $breakpoint-lg) {
      margin-right: 24px;
      margin-bottom: 0;
    }
  }

  &__description {
    font-size: var(--font-size-paragraph-s);
    margin-bottom: 0;
  }
}
</style>
